import * as React from "react";
import { Link, Typography } from "@mui/material";
import LegalDocumentPage from "./LegalDocumentPage";

export default function PrivacyPolicy() {
  return (
    <LegalDocumentPage title="Privacy Policy" lastUpdated="27 August 2026">
      <Typography>
        The SEEDS platform is developed within the <strong>SEEDS PRIMA research
        project (Grant Agreement No. 2332)</strong> to support agricultural
        research, monitoring and collaboration.
      </Typography>

      <Typography>
        The platform may collect and process information such as <strong>first
        name, last name, email address, role, comments, profile and post
        images</strong>, as well as agricultural data including <strong>location,
        field, crop, variety, area/acres, latitude, longitude, crop cycle,
        season, crop stage and soil, weather and environmental measurements</strong>.
      </Typography>

      <Typography>
        These data are used only to operate the SEEDS platform, support project
        and research activities, enable collaboration between users, and
        analyse agricultural information.
      </Typography>

      <Typography>
        Personal data is processed in accordance with the <strong>General Data
        Protection Regulation (GDPR – Regulation (EU) 2016/679)</strong> and
        applicable data-protection legislation. Where consent is required,
        users may withdraw it at any time. Data is kept only for as long as
        necessary for the purposes of the platform, project, or applicable
        legal and research requirements.
      </Typography>

      <Typography>
        The Sign Up form uses <strong>Google reCAPTCHA</strong> to protect the
        platform from spam and automated abuse. Google may process technical
        information such as the user's IP address, browser and device
        information for this security purpose. Google's{" "}
        <Link
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </Link>{" "}
        apply.
      </Typography>

      <Typography>
        Personal data is not sold or used for unrelated commercial purposes and
        is accessible only to authorised users.
      </Typography>

      <Typography>
        Users may request access to, correction or deletion of their personal
        data, or exercise other rights available under the GDPR.
      </Typography>

      <Typography>
        <strong>Contact:</strong>{" "}
        <Link href="mailto:laz@iti.gr">laz@iti.gr</Link>
      </Typography>
    </LegalDocumentPage>
  );
}
